module.exports = __webpack_public_path__ + "img/zc2.c923ef8a.png";